export const slcGeoCoords = {
  latitude: 40.538125,
  longitude: -111.820688
};
